<template>
  <van-overlay :show="show" @click="onClose" :z-index="102">
    <div class="popup_box">
      <div class="share-content">
        <div class="share-continer">
          <div class="popup-title">{{ $t('envelope.receiveCash') }}</div>
          <div class="amount">
            {{ reward ? formatMoney(reward.currentReward) : '--' }}
            {{ unitConversion(balance.currencyAlias) }}
          </div>
          <!-- <div class="share-title">RECEIVE CASH</div>
          <div class="share-amount">{{ reward ? formatMoney(reward.currentReward) : 0 }}
            {{ unitConversion(balance.currencyAlias) }}</div> -->
          <ShareProgress />
        </div>
      </div>
      <div class="share-button" @click="onWitchDraw">
        {{ $t('envelope.shareagain') }}
        <img v-if="!isFinishGuide" class="guid" :src="guidHand" alt="" srcset="" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { config } from '@/common/config'
import ShareProgress from '@/components/active/ShareProgress.vue'
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'pinia'
import { showSuccessToast } from 'vant'
export default {
  name: 'LobbyActiveSharePopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      progress: 60,
      guidHand: `${config.resBaseUrl}clickgif.gif`,
      // clickInviteBtn: getLocalStorage(Key.clickInviteBtn) == 'true'
      isFinishGuide: true
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },
  mounted() {
    this.envelope().then((r) => {
      this.updateReward(r)
      this.progress = Math.max(Math.round((r.currentReward / r.totalReward) * 100), 30)
    })
    this.guide().then((r) => {
      this.isFinishGuide = r.guide
    })
  },
  methods: {
    formatMoney,
    unitConversion,
    dayjs,
    ...mapActions(useEnvelopeStore, {
      claim: 'claim',
      envelope: 'envelope',
      updateReward: 'updateReward',
      guide: 'guide',
      finishGuide: 'finishGuide'
    }),
    onWitchDraw() {
      if (this.reward.status == 2) {
        this.claim(this.reward.id).then((res) => {
          console.log(res)
          this.finishGuide()
          showSuccessToast({
            message: 'Claim successfully',
            wordBreak: 'break-word',
            onClose: () => {
              this.cancel()
            },
            duration: 3000
          })
        })
      }
    },
    onClose() {
      // setLocalStorage(Key.clickInviteBtn, true)
      this.finishGuide()
      this.cancel()
    }
  },
  components: { ShareProgress }
}
</script>

<style lang="scss" scoped>
.popup_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .share-content {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-direction: column;
    width: 5rem;
    height: 2.7rem;
    background: #f1f1f1;
    border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
    border: 0.02rem solid #95a5a5;

    .share-continer {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      margin-top: 0.8rem;

      .popup-title {
        width: 100%;
        height: 0.25rem;
        font-family: DroidSans;
        font-size: 0.24rem;
        color: #009944;
        line-height: 0.4rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: -0.54rem;
      }

      .amount {
        width: 100%;
        height: 0.56rem;
        font-family: Oswald;
        font-weight: bold;
        font-size: 0.6rem;
        color: #009944;
        text-align: center;
        margin-bottom: 0.3rem;
        scale: 0.8 1;
      }

      .info-button {
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 0.16rem;

        // height: 0.2rem;
        font-family: Droid Sans;
        font-weight: 400;
        font-size: 0.24rem;
        color: #ffffff;
        margin: 0.29rem 0 0 0;
        box-shadow:
          0rem 0rem 0rem 0rem #266aac,
          0rem 0rem 0rem 0rem #266aac;

        width: auto;
        padding: 0 0.3rem;
        height: 0.8rem;
        background: #336aea;
        border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      }
    }
  }

  .share-button {
    display: flex;
    justify-content: center;
    width: 5rem;
    height: 0.7rem;
    background: #336aea;
    border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
    font-family: DroidSans;
    font-size: 0.24rem;
    color: #ffffff;
    line-height: 0.7rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding: 0.1rem 0;
    margin-top: 0.38rem;

    .guid {
      position: absolute;
      margin-top: -0.3rem;
      margin-left: 3.8rem;
      width: 1.5rem;
    }
  }
}
</style>
